import {EmptyObject} from './constants';
import {isObjectWithKeys} from '@snapper/core';

export const initThemeOverrideFromURLParams = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const {id: _, ...theme} = Object.fromEntries(urlParams.entries());

    if (!isObjectWithKeys(theme)) {
      localStorage.removeItem('defaultTheme');

      return null;
    }

    const {
      color: bgColor,
      colorTo: bgToColor,
      txtColor,
      defaultFont,
      defaultFontTitle,
    } = theme || {};

    const color = bgColor || bgToColor;
    const colorTo = bgToColor === color
      ? undefined
      : bgToColor;

    const bgInputType = colorTo
      ? 'gradient'
      : 'solid';

    const fontTxt = defaultFont || defaultFontTitle;

    const defaultTheme = {
      color,
      colorTo,
      bgInputType,
      txtColor,
      defaultFont: fontTxt,
      defaultFontTitle: defaultFontTitle === fontTxt
        ? undefined
        : defaultFontTitle,
    };

    localStorage.setItem('defaultTheme', JSON.stringify(defaultTheme));

    return defaultTheme;
  } catch (error) {
    console.error(error);

    return null;
  }
};

export const getThemeFromURLParams = () => {
  try {
    const defaultTheme = localStorage.getItem('defaultTheme'); // better to always get from params?

    return JSON.parse(defaultTheme) || EmptyObject;
  } catch (error) {
    console.error(error);

    return EmptyObject;
  }
};